import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Get_Catagory } from "../Redux/action";
import Navbar from '../header-footer/nav';
import MovieItem from '../Home/movie_item';
import Pagination from "react-js-pagination";
import MovieHelmet from '../SEO/MovieHelmet';
import MovieSkeleton from '../Home/moviesItemSkeletion'
export const Genres = () => {
    const genres = useParams();
    const Getagorys = useSelector(state => state.FetCatagory);
    const Getagory = Getagorys.Catagory
    const dispatch = useDispatch();
    const IndexSt = Array.from({ length: 20 });
    const [currentPage, setCurrentPage] = useState(1);
    const [params, setparams] = useState(genres.genres);

    const PagenaTion = (pageNumber) => {
        setCurrentPage(pageNumber);
        dispatch(Get_Catagory(genres.genres, pageNumber));
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    useEffect(() => {
        if (genres.genres === params) {
            dispatch(Get_Catagory(genres.genres, currentPage))
            setparams(genres.genres)
        } else {
            dispatch(Get_Catagory(genres.genres, 1))
            setCurrentPage(1)
            setparams(genres.genres)
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [genres, currentPage, params, dispatch])
    return (
        <div className="container mt-5">
            <MovieHelmet title={params} />
            <div className="row">
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xxl-3">
                    <div className="sticky-md-top sticky-lg-top sticky-xl-top">
                        <div className="d-md-flex align-items-center d-none d-md-block justify-content-between my-4 pb-1 w-100">
                            <h4 className="font-size-24 font-weight-medium m-0">Explore</h4>
                        </div>
                        <div className="d-none d-sm-block">
                            <Navbar paramActive={params} />
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xxl-9">
                    <div className="d-md-flex align-items-center justify-content-between my-4 pb-1 w-100">
                        <h4 className="font-size-24 font-weight-medium m-0 text-capitalize">{genres.genres}&nbsp;</h4>
                        <div className="d-none d-md-block border-top-theme col p-0 mt-2 border-gray-6830"></div>
                    </div>
                    {!Getagorys.loading ?
                        <div className="row mt-3 container-card">
                            {
                                Getagory && Getagory.map((Movies, index) => {
                                    return (
                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xxl-3 px-2" key={index}>
                                            <MovieItem {...Movies} />
                                        </div>
                                    )
                                })

                            }
                            <div className="mt-5 text-center">
                                {
                                    Getagory?.length > 0 ?
                                        <Pagination
                                            activePage={currentPage}
                                            itemsCountPerPage={20}
                                            totalItemsCount={450}
                                            pageRangeDisplayed={5}
                                            onChange={PagenaTion} /> :
                                        <div>
                                            <img className="img-fluid w-50" src={process.env.PUBLIC_URL + "/no-file.png"} alt="No Movies" />
                                            <h2>No Movies</h2>
                                        </div>
                                }

                            </div>
                        </div> :

                        <div className="row mt-3 container-card">
                            {
                                IndexSt && IndexSt.map((index) => {
                                    return (
                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xxl-3 " key={index} >
                                            <MovieSkeleton />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Genres;